export default "__VITE_ASSET__TIvSvzZf__"